(ns practitest.frontend.kanban.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  :kanban/projects
  (fn [db _]
    (:all-projects db)))

(re-frame/reg-sub
  :kanban/current-project
  (fn [db _]
    (:current-project-id db)))

(re-frame/reg-sub
  :kanban/lanes
  (fn [db _]
    (->> (vals (:kanban/lanes db))
         (sort-by :position)
         (map (fn [lane]
                (update lane :cards
                        (fn [cards]
                          (sort-by :position (vals cards)))))))))

(re-frame/reg-sub
  :kanban/current-users
  (fn [db _]
    (->> (vals (:kanban/online-users db)))))

(re-frame/reg-sub
  :kanban/user-gravatars
  (fn [db _]
    (:user-gravatars db)))



(re-frame/reg-sub
  :kanban/dragging
  (fn [db _]
    (:kanban/dragging db)))

(re-frame/reg-sub
  :kanban/cards
  (fn [db [_ lane-id]]
    (let [card-types-filter  (re-frame/subscribe [:kanban/card-types-filter])
          assigned-to-filter (re-frame/subscribe [:kanban/assigned-to-filter])
          cards              (->> (vals (get-in db [:kanban/lanes lane-id :cards]))
                                  (filter #(or
                                             (nil? @card-types-filter)
                                             (= "none" @card-types-filter)
                                             (= @card-types-filter (:entity %))))
                                  (filter #(or
                                             (nil? @assigned-to-filter)
                                             (= "none" @assigned-to-filter)
                                             (= @assigned-to-filter (get-in % [:assigned_to :type-id]))))
                                  (map (fn [card]
                                         (assoc card :read-only?
                                                     (not (get-in db [:permissions (keyword (:entity card)) :can-edit?]))))))
          users              (:kanban/online-users db)]
      (->> cards
           (map (fn [card]
                  (let [users (filter #(= (:editing %)
                                          [(:entity card) (:system_id card)])
                                      (vals users))]
                    (assoc card :editing users))))
           (sort-by :position)))))

(re-frame/reg-sub
  :kanban/can-edit-lanes?
  (fn [db _]
    (:can-edit-lanes? db)))

(re-frame/reg-sub
  :kanban/mode
  (fn [db _]
    (:mode db)))

(re-frame/reg-sub
  :kanban/card-types-filter
  (fn [db _]
    (:card-types-filter db)))

(re-frame/reg-sub
  :kanban/show-user-list?
  (fn [db _]
    (get-in db [:user-list :show?])))

(re-frame/reg-sub
  :kanban/show-action-log?
  (fn [db _]
    (get-in db [:action-log :show?])))

(re-frame/reg-sub
  :kanban/action-log
  (fn [db _]
    (get-in db [:action-log :actions])))

(re-frame/reg-sub
  :kanban/project-users
  (fn [db _]
    (:project-users db)))

(re-frame/reg-sub
  :kanban/assigned-to-filter
  (fn [db _]
    (:assigned-to-filter db)))

(re-frame/reg-sub
  :kanban/restricted-view?
  (fn [db _]
    (not-every? :can-view? (vals (:permissions db)))))

(re-frame/reg-sub
  :kanban/restricted-edit?
  (fn [db _]
    (not-every? :can-edit? (vals (:permissions db)))))

(re-frame/reg-sub
  :kanban/can-run-testset?
  (fn [db _]
    (get-in db [:permissions :Suite :can-run?])))
